<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title class="bg-primary text-white">
            <v-icon class="mr-2">mdi-help-circle</v-icon>
            Manual de Instruções - Processos
          </v-card-title>
          
          <v-tabs v-model="tab" bg-color="grey-lighten-4" color="primary">
            <v-tab value="importacao">
              <v-icon class="mr-2">mdi-ship</v-icon>
              Importação
            </v-tab>
            <v-tab value="exportacao">
              <v-icon class="mr-2">mdi-package-variant</v-icon>
              Exportação
            </v-tab>
          </v-tabs>

          <v-card-text class="pa-4">
            <v-window v-model="tab">
              <!-- Importação -->
              <v-window-item value="importacao">
                <v-expansion-panels variant="accordion" multiple>
                  <v-expansion-panel
                    v-for="status in importacaoStatuses"
                    :key="status.id"
                  >
                    <v-expansion-panel-title>
                      <div class="d-flex align-center w-100">
                        <span class="text-h6 mr-3">{{ status.icon }}</span>
                        <div class="flex-grow-1">
                          <div class="font-weight-bold">{{ status.descr }}</div>
                          <div class="text-caption text-grey">
                            Status {{ status.id }}
                            <span v-if="status.followUpDays" class="ml-2">
                              • Follow-up: {{ status.followUpDays }} dia(s)
                            </span>
                          </div>
                        </div>
                        <v-chip
                          :color="status.color"
                          size="small"
                          class="ml-2"
                        />
                      </div>
                    </v-expansion-panel-title>
                    
                    <v-expansion-panel-text>
                      <v-divider class="mb-3" />
                      <div 
                        class="status-instructions" 
                        v-html="getInstruction(status.instructionKey)"
                      />
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-window-item>

              <!-- Exportação -->
              <v-window-item value="exportacao">
                <v-expansion-panels variant="accordion" multiple>
                  <v-expansion-panel
                    v-for="status in exportacaoStatuses"
                    :key="status.id"
                  >
                    <v-expansion-panel-title>
                      <div class="d-flex align-center w-100">
                        <span class="text-h6 mr-3">{{ status.icon }}</span>
                        <div class="flex-grow-1">
                          <div class="font-weight-bold">{{ status.descr }}</div>
                          <div class="text-caption text-grey">
                            Status {{ status.id }}
                            <span v-if="status.followUpDays" class="ml-2">
                              • Follow-up: {{ status.followUpDays }} dia(s)
                            </span>
                          </div>
                        </div>
                        <v-chip
                          :color="status.color"
                          size="small"
                          class="ml-2"
                        />
                      </div>
                    </v-expansion-panel-title>
                    
                    <v-expansion-panel-text>
                      <v-divider class="mb-3" />
                      <div 
                        class="status-instructions" 
                        v-html="getInstruction(status.instructionKey)"
                      />
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useProjectStore } from '../stores/projects'

const projectStore = useProjectStore()
const tab = ref('importacao')

const importacaoStatuses = computed(() => {
  const projectType = projectStore.projectTypes.find(pt => pt.id === 0)
  return projectType?.statusList || []
})

const exportacaoStatuses = computed(() => {
  const projectType = projectStore.projectTypes.find(pt => pt.id === 1)
  return projectType?.statusList || []
})

const getInstruction = (instructionKey) => {
  if (!instructionKey) return '<p><em>Sem instruções disponíveis.</em></p>'
  
  const [typeKey, statusKey] = instructionKey.split('.')
  return projectStore.instructions[typeKey]?.[statusKey] || '<p><em>Instruções não encontradas.</em></p>'
}

onMounted(async () => {
  if (!projectStore.projectTypes || projectStore.projectTypes.length === 0) {
    await projectStore.loadConfigurations()
  }
})
</script>

<style scoped>
.status-instructions {
  line-height: 1.7;
}

.status-instructions :deep(p) {
  margin-bottom: 0.5rem;
}

.status-instructions :deep(ol) {
  margin-left: 0;
  padding-left: 1.5rem;
}

.status-instructions :deep(ul) {
  margin-left: 0;
  padding-left: 1.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.status-instructions :deep(li) {
  margin-bottom: 0.5rem;
}

.status-instructions :deep(strong) {
  color: #1976d2;
  font-weight: 600;
}

.status-instructions :deep(em) {
  color: #666;
  font-style: italic;
}

.status-instructions :deep(.text-success) {
  color: #4caf50;
}

.status-instructions :deep(.tip) {
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 0.75rem;
  margin-top: 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
}
</style>
